<div class="user-menu-trigger" (click)="toggleMenu($event)">
  <div class="user-avatar">{{ initials() }}</div>
  <span class="user-name">{{ displayName() }}</span>
  <i class="pi pi-chevron-down user-chevron"></i>
</div>

<p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
